import { Route } from '@angular/router';

export const lmInfProductRootRoutes: Route[] = [];
